<template>
  <div :class="{ 'pa-4': $vuetify.breakpoint.mdAndUp }">
    <v-row
      :class="{
        'px-3 mt-2': $vuetify.breakpoint.smAndDown,
        'mx-n2': $vuetify.breakpoint.mdAndUp
      }"
      class="mb-2"
      no-gutters
    >
      <v-col>
        <Breadcrumbs headline="Lớp học" :link="[{ text: 'Lớp học', href: classHref }]" />
      </v-col>
    </v-row>

    <v-card class="px-4">
      <v-row class="px-1">
        <v-col class="text-right">
          <span v-if="$vuetify.breakpoint.smAndDown">
            <class-filter-dialog @onFilterChanged="refresh" />
          </span>
          <setting-table-header :default-headers="headers" @change="headers = $event" />
          <span v-if="$vuetify.breakpoint.mdAndUp">
            <kebap-menu>
              <v-list>
                <v-list-item>
                  <export-excel :custom-header="headers" api="/classes/" />
                </v-list-item>
              </v-list>
            </kebap-menu>
          </span>
        </v-col>
      </v-row>
      <class-filter v-if="$vuetify.breakpoint.mdAndUp" @onFilterChanged="refresh" />
      <BaseTableSkeletonLoader v-if="isLoadingClasses"></BaseTableSkeletonLoader>
      <v-data-table
        v-else
        item-key="id"
        :headers="headers"
        :items="formatedClasses"
        :search="search"
      >
        <template v-slot:item.status="{ item }">
          <v-chip
            small
            label
            dark
            style="width: 86px; justify-content: center"
            :color="getColor(item.status)"
            >{{ item.status | classStatus }}</v-chip
          >
        </template>
        <template v-slot:item.code="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <router-link style="text-decoration: none" :to="'/class/' + item.id">{{
                  item.code
                }}</router-link>
              </div>
            </template>
            <span>Xem Lớp</span>
          </v-tooltip>
        </template>
        <template v-slot:item.course="{ item }">
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <router-link
                  v-on="on"
                  style="text-decoration: none"
                  :to="'/course/' + getCourse(item.course).id"
                  >{{ getCourse(item.course).title }}</router-link
                >
              </div>
            </template>
            <span>Xem Khóa Học</span>
          </v-tooltip> -->
          {{ getCourse(item.course).title }}
        </template>
        <template v-slot:item.major="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <router-link
                  v-if="item.major"
                  style="text-decoration: none"
                  :to="getMajor(item.major).id"
                  >{{ getMajor(item.major).title }}</router-link
                >
              </div>
            </template>
            <span>Xem Chuyên Ngành</span>
          </v-tooltip>
        </template>
        <template v-slot:item.startTime="{ item }">
          <p style="margin: 0">{{ item.startTime | displayDate }}</p>
        </template>
        <template v-slot:item.students="{ item }">
          <p style="margin: 0">{{ item.students | studentCounter }}</p>
        </template>
        <template v-slot:item.teachers="{ item }">
          <p style="margin: 0">{{ item | getTeacherNames }}</p>
        </template>
        <template v-slot:item.generation="{ item }">
          <p style="margin: 0">{{ item.generation | getGeneration }}</p>
        </template>
        <template v-slot:item.room="{ item }">
          <p style="margin: 0; white-space: nowrap">
            {{ item.room | getRoom }}
          </p>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import BaseTableSkeletonLoader from '@/components/base/BaseTableSkeletonLoader'
import { mapActions, mapState, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ClassFilter from '@/modules/class/ClassFilter'
import ClassFilterDialog from '@/modules/class/ClassFilterDialog'
import ExportExcel from '@/components/basic/ExportExcel'
import KebapMenu from '@/components/basic/menu/KebapMenu'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import moment from 'moment'
import _ from 'lodash'

export default {
  components: {
    ClassFilter,
    ClassFilterDialog,
    ExportExcel,
    KebapMenu,
    SettingTableHeader,
    BaseTableSkeletonLoader,
    Breadcrumbs
  },
  props: {
    role: String
  },
  data() {
    return {
      headers: [
        {
          text: 'Mã Lớp',
          value: 'code',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Môn Học',
          value: 'course',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Chuyên Ngành',
          value: 'major',
          align: 'left',
          sortable: false,
          show: false
        },
        {
          text: 'Nhóm',
          value: 'tags',
          align: 'left',
          sortable: true,
          show: true
        },
        {
          text: 'Phòng Học',
          value: 'room',
          align: 'left',
          sortable: true,
          show: false
        },
        {
          text: 'Giáo Viên',
          value: 'teachers',
          align: 'left',
          sortable: true,
          show: false
        },
        {
          text: 'Khóa',
          value: 'generation',
          align: 'left',
          sortable: true,
          show: false
        },
        {
          text: 'Sĩ Số',
          value: 'students',
          align: 'left',
          sortable: true,
          show: true
        },
        {
          text: 'Khai Giảng',
          value: 'startTime',
          align: 'left',
          sortable: true,
          show: false
        },
        {
          text: 'Trạng Thái',
          value: 'status',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Vai trò',
          value: 'role',
          align: 'left',
          sortable: false,
          show: true
        }
      ],
      draw: false,
      search: '',
      status: null
    }
  },
  async created() {
    await this.refresh({})
  },
  computed: {
    ...mapState('class', ['count', 'classData', 'isLoadingClasses']),
    ...mapState('app', ['department']),
    ...mapState('auth', ['profile', 'user']),
    ...mapGetters('class', ['classes']),
    classHref() {
      if (!this.user || !this.user.role) {
        return ''
      }
      if (['teacher'].includes(this.user.role.type)) {
        return '../teacher-classes'
      }
      return '../classes'
    },
    formatedClasses() {
      if (!this.user) {
        return this.classes
      }
      return this.classes.map(item => {
        const { teachers, mentors, grading_teachers } = item

        const roles = []
        if (teachers.find(t => t.code === this.user.username)) {
          roles.push('Giáo viên')
        }
        if (mentors.find(t => t.code === this.user.username)) {
          roles.push('Trợ giảng')
        }
        if (grading_teachers.find(t => t.code === this.user.username)) {
          roles.push('GV chấm cuối môn')
        }

        return { ...item, role: roles.join(', ') }
      })
    }
  },
  methods: {
    ...mapActions('class', ['fetchClasses', 'countClasses', 'setClass', 'setClasses']),
    updateDraw(draw) {
      this.draw = draw
    },
    getColor(status) {
      if (status === 'opened') return 'green'
      if (status === 'running') return 'primary'
      else if (status === 'pending' || status === 'rejected') return 'red'
      else if (status === 'done') return 'gray'
      else return 'red'
    },
    getMajor: major => {
      return major || {}
    },
    getCourse: course => {
      return course || {}
    },
    async refresh(query) {
      if (!(this.profile || {}).id) {
        return
      }
      await this.setClasses([])
      await this.countClasses()
      await this.fetchClasses({
        omit_students: true,
        department: this.department.id,
        '_where[_or][0][teachers]': this.profile.id,
        '_where[_or][1][mentors]': this.profile.id,
        '_where[_or][2][grading_teachers]': this.profile.id,
        // teachers: this.profile.id,
        ...query
      })
    }
  },
  watch: {
    profile() {
      this.refresh()
    }
  },
  filters: {
    studentCounter: students => {
      if (!students) {
        return 0
      }
      return students.length
    },
    classStatus: status => {
      if (status === 'opened') return 'Đang chờ'
      else if (status === 'running') return 'Đang Chạy'
      else if (status === 'rejected') return 'Bị Từ Chối'
      else if (status === 'canceled') return 'Đã Hủy'
      else if (status === 'done') return 'Kết Thúc'
      else return 'Không rõ'
    },
    getTeacherNames: classData => {
      return classData.teachers.map(teacher => teacher.name).join(',')
    },
    getGeneration: item => {
      return _.get(item, 'name', '')
    },
    getRoom: item => {
      return _.get(item, 'title', '')
    },
    displayDate: date => {
      if (date) return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>
